/**
 * @file: 执行更新任务
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../cubeTree/index';
import * as Toolkit from '../toolkit/index';
import FrontCubeData from '../frontCubeData/index';
import NextTick from '../utils/nextTick';
import Utils from '../utils/util';
import CodiSystem from '../codiSystem/index';
import FindNeedUpdateCubeIds from './cubeNeedUpdate';
import { layerLink } from '../interaction/layerGroup/link';
import { cubeModify } from './cubeModify';
import { doneAsync } from './done';
import { updateCubeList } from './updateCubeList';
import { updateCodiSystem } from './updateCodiSystem';
import { updateEnd } from './updateEnd';
import { runTaskQueue } from './runTaskQueue';

// 必须同步执行
function run(updateTaskQueue: Array<UpdateTask>): void {
    let logInfo: Array<FreeObjMap> = [];

    Toolkit.log({
        action: '更新',
        msgList: [
            {
                name: '更新任务队列:',
                value: updateTaskQueue
            }
        ]
    });
    if (!updateTaskQueue.length) {
        updateEnd();
        return;
    }

    // 计算需要更新的cube
    let needUpdateCubeIds: CubeId[] = FindNeedUpdateCubeIds(updateTaskQueue);

    runTaskQueue(updateTaskQueue);
    Toolkit.log({
        action: '更新',
        msgList: [
            {
                name: '被计算出的需要更新的cubeId列表:',
                value: needUpdateCubeIds
            }
        ]
    });

    // IDEA: 这里可以考虑微任务执行
    // 触发渲染
    updateCubeList(needUpdateCubeIds);
    updateEnd();
}

// 触发所有组件的update方法
function updateAllCubes() {
    let sketchpad: CubeId = CubeTree.findSketchpad();
    let allCubes: Array<CubeId> = CubeTree.findChildCubeIds(sketchpad);

    allCubes.forEach((cube: CubeId): void => {
        deepUpdate(cube);
    });
    updateEnd();
}

function deepUpdate(cubeId: CubeId): void {
    let cube: CubeNode = CubeTree.findByCubeId(cubeId);
    let childCubeIds: Array<CubeId> = CubeTree.findChildCubeIds(cubeId);

    cube.update();
    childCubeIds.forEach((child: CubeId): void => {
        deepUpdate(child);
    });
}

export {
    run,
    updateAllCubes
};
